// Proveedor de transporte por defecto para conexiones nuevas.
// Este es el ÚNICO lugar donde el string "baileys" está hardcodeado en el frontend.
// Todos los componentes y hooks deben importar este valor en lugar de escribirlo inline.
export const DEFAULT_PROVIDER = "baileys";

export const PROVIDERS = {
  BAILEYS:   "baileys",
  EVOLUTION: "evolution",
  WABA:      "waba",
  FACEBOOK:  "facebook",
  INSTAGRAM: "instagram",
  TIKTOK:    "tiktok",
  // No es un transporte de mensajería (no envía/recibe WhatsApp) — es un
  // formulario de captación (doc 0417) que usa una conexión existente por
  // detrás. Vive en el mismo catálogo solo para que `ChannelIcon` resuelva
  // su logo con el mismo mecanismo que los demás canales.
  WEBFORM:   "webform",
};

/**
 * Devuelve la etiqueta legible del proveedor de canal para mostrar en la UI.
 * Única fuente de verdad — todos los componentes deben importar esta función.
 */
export function getWhatsAppProviderLabel(provider) {
  switch (String(provider || "").toLowerCase()) {
    case "baileys":
    case "beta":      return "API Baileys";
    case "evolution": return "Evolution API";
    case "waba":      return "WABA Meta";
    case "facebook":  return "Facebook";
    case "instagram": return "Instagram DM";
    case "tiktok":    return "TikTok";
    case "webform":   return "Formulario Web";
    default:          return provider ? String(provider) : "API Baileys";
  }
}

/**
 * Logo del canal, servido desde `public/`.
 *
 * WHY aquí y no en cada componente: el proveedor ya decide su etiqueta en este archivo;
 * el logo es la otra mitad de la misma identidad. Repartir el `switch` por la UI llevaría
 * a que el menú, la tarjeta y el chip del ticket se desincronicen al añadir un canal.
 *
 * WHY archivos locales y no un CDN: la tarjeta de conexión enlazaba el SVG de WhatsApp
 * desde Wikimedia. Un cliente tras un firewall corporativo, o un servidor con salida
 * restringida, se quedaba sin icono en toda la pantalla.
 *
 * Los transportes no oficiales —Baileys y Evolution— comparten el logo de WhatsApp a
 * propósito: para el usuario son el mismo canal, cambia el camino técnico.
 */
const PROVIDER_ICONS = {
  [PROVIDERS.BAILEYS]:   "/whatsapp.png",
  [PROVIDERS.EVOLUTION]: "/whatsapp.png",
  [PROVIDERS.WABA]:      "/whatsapp-api.png",
  [PROVIDERS.FACEBOOK]:  "/messenger.png",
  [PROVIDERS.INSTAGRAM]: "/instagram.png",
  [PROVIDERS.WEBFORM]:   "/webform.svg",
};

/**
 * Devuelve la ruta del logo del canal. Ante un proveedor desconocido —o ausente, como
 * cuando el backend aún no lo envía— cae a WhatsApp, que es el canal por defecto: la UI
 * nunca se queda con un hueco.
 */
export function getWhatsAppProviderIcon(provider) {
  const key = String(provider || "").toLowerCase();
  // "beta" es el alias histórico de Baileys; lo resuelve igual que getWhatsAppProviderLabel.
  if (key === "beta") return PROVIDER_ICONS[PROVIDERS.BAILEYS];
  return PROVIDER_ICONS[key] || PROVIDER_ICONS[DEFAULT_PROVIDER];
}

// Razones de desconexión normalizadas (agnósticas al proveedor).
// El backend mapea sus códigos internos (BAD_SESSION, etc.) a estos valores.
// La UI solo debe conocer este enum.
export const DISCONNECT_REASONS = {
  // Valor canónico: DEBE coincidir con MANUAL_DISCONNECT_REASONS del backend
  // (crm-baileys/domain/ReconnectPolicy). Solo con "USER_DISCONNECT" el STOP corta
  // la reconexión automática (isManual) y el backend cierra el transporte del canal.
  USER_DISCONNECT: "USER_DISCONNECT",
  SESSION_CORRUPT: "SESSION_CORRUPT",
  NETWORK_ERROR:   "NETWORK_ERROR",
  SERVER_RESTART:  "SERVER_RESTART",
};
